function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { useCallback } from 'react';
import { useQueryUrl } from './useQueryUrl';

/**
 * Get current param from url and change it in location search
 */
export var useQueryParam = function useQueryParam(paramName, defaultValue) {
  var _useQueryUrl = useQueryUrl(),
      params = _useQueryUrl.params,
      setQuery = _useQueryUrl.setQuery;

  var param = typeof params[paramName] === 'string' ? params[paramName] : defaultValue;
  var setParam = useCallback(function (value) {
    setQuery(_defineProperty({}, paramName, value === defaultValue ? '' : value));
  }, [defaultValue, setQuery]);
  return [param, setParam];
};